import { footerData } from '@/mocks/homeData';

export default function Footer() {
  return (
    <footer id="footer" className="bg-background-900 text-foreground-200">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-1">
            <span className="text-xl font-heading text-background-50">97影视</span>
            <p className="mt-4 text-sm text-foreground-400 leading-relaxed">
              {footerData.description}
            </p>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">快速导航</h4>
            <ul className="space-y-2.5">
              {footerData.links.slice(0, 3).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">更多入口</h4>
            <ul className="space-y-2.5">
              {footerData.links.slice(3).map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-foreground-400 hover:text-primary-400 transition-colors cursor-pointer"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-foreground-500">优质影视资源平台合作招募中</p>
          </div>
        </div>

        <div className="border-t border-background-700/50 mt-10 pt-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <p className="text-xs text-foreground-500">
            &copy; {new Date().getFullYear()} 97影视. All Rights Reserved.
          </p>
          <p className="text-xs text-foreground-500">
            本站资源来源于网络，仅供交流学习使用
          </p>
        </div>
      </div>
    </footer>
  );
}